import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { MetaDrivenTable, PaginationControls } from "../../../shared/components";
import { formatCurrency } from "../../../shared/utils";
import { useAdjustments } from "../hooks/useAdjustment";

export const Adjustments: React.FC<{ projectId: string | undefined }> = ({ projectId }) => {

    const { isLoading, isError, error, data, pagination, changePage, changeRowsPerPage } = useAdjustments(projectId);

    const headers = [
        { "alias_name": "from_budget_name", "label": "From Budget Name", "display_order": 1, "is_show": true },
        { "alias_name": "amount", "label": "Amount", "display_order": 2, "is_show": true },
        { "alias_name": "reason", "label": "Reason", "display_order": 3, "is_show": true },
        { "alias_name": "created_by", "label": "Created By", "display_order": 4, "is_show": true },
    ];

    const metrics = {
        "amount": {
            type: "component",
            element: (row: { amount: string }) => formatCurrency(Number(row.amount))
        },
    };

    if (isLoading) {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
                gap={2}
            >
                <CircularProgress />
            </Box>
        )
    };

    return (
        <Box flex={1} height={'100%'} display={'flex'} flexDirection={'column'}>
            <Box flex={1} sx={{ overflowX: "hidden", overflowY: "auto" }}>
                <MetaDrivenTable headers={headers} data={data} dataMetrics={metrics} sortDisabled={true} />
            </Box>
            <Box flexShrink={0}>
                <PaginationControls
                    total={pagination?.total}
                    rowsPerPage={pagination?.limit}
                    currentPage={pagination?.page}
                    handleRowsPerPage={changeRowsPerPage}
                    handlePageChange={changePage}
                />
            </Box>
        </Box>
    );

};